"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("styles/index.scss");
var react_1 = __importDefault(require("react"));
var client_1 = require("react-dom/client");
var App_1 = require("./App");
var container = document.getElementById("root");
var root = (0, client_1.createRoot)(container !== null && container !== void 0 ? container : document.body);
root.render(react_1.default.createElement(App_1.App, null));
